import type { SVGProps } from "react";
export default function EmailSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={112}
      height={111}
      fill="none"
      viewBox="0 0 112 111"
      className="flex shrink-0 grow-0"
      {...props}
    >
      <g clipPath="url(#clip0_15340_9624)">
        <circle cx={56} cy={55.5} r={55.5} fill="#2F6B58" />
        <mask
          id="mask0_15340_9624"
          width={112}
          height={111}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "alpha",
          }}
        >
          <circle cx={56} cy={55.5} r={55.5} fill="#2F6B58" />
        </mask>
        <g mask="url(#mask0_15340_9624)">
          <mask
            id="mask1_15340_9624"
            width={48}
            height={35}
            x={32}
            y={57}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: "alpha",
            }}
          >
            <rect
              width={46.737}
              height={34.496}
              x={32.632}
              y={57.447}
              fill="#FF5734"
              rx={5}
            />
          </mask>
          <g mask="url(#mask1_15340_9624)">
            <rect
              width={46.737}
              height={34.496}
              x={32.632}
              y={57.447}
              fill="#FF5734"
              rx={5}
            />
            <rect
              width={35.197}
              height={35.197}
              fill="#FF9A84"
              rx={5}
              transform="scale(.98817 1.0117)rotate(45 -51.883 102.412)"
            />
            <rect
              width={35.197}
              height={35.197}
              fill="#FFCDC2"
              rx={5}
              transform="scale(-.98817 -1.0117)rotate(-45 -109.651 69.724)"
            />
          </g>
        </g>
        <path
          fill="#fff"
          d="M82.131 21.42a6 6 0 0 1 6 6v12.343a6 6 0 0 1-6 6H29.868a6 6 0 0 1-6-6V27.42a6 6 0 0 1 6-6z"
        />
        <rect
          width={5.994}
          height={5.994}
          x={51.132}
          y={44.79}
          fill="#fff"
          rx={1}
          transform="rotate(-45 51.132 44.79)"
        />
        <rect
          width={12.658}
          height={13.632}
          x={43.342}
          y={27.263}
          fill="#D1D1D1"
          rx={3}
          transform="rotate(90 43.342 27.263)"
        />
        <rect
          width={3.895}
          height={26.29}
          x={75.474}
          y={27.263}
          fill="#D1D1D1"
          rx={1.947}
          transform="rotate(90 75.474 27.263)"
        />
        <rect
          width={3.895}
          height={16.553}
          x={65.737}
          y={34.079}
          fill="#D1D1D1"
          rx={1.947}
          transform="rotate(90 65.737 34.079)"
        />
      </g>
      <defs>
        <clipPath id="clip0_15340_9624">
          <rect
            width={111}
            height={111}
            fill="#fff"
            transform="translate(.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
